import React from "react";
import { DataTable } from "./DataTable";
import { Button, message, Upload } from "antd";
import { useCardModel } from "../cardModel";
import { YhBox } from "@/components/YhBox";
import { importPropsConfig1 } from "@/utils/importFile1";
import { convertRes2Blob } from "@/utils/exportFile";
import { cardService } from "../cardService";

export const DataBox = () => {
    const { setICardDrawer, setSyncVisible, selectedRowKeys, loadData, sync, downloadTpl, setLoadingInfo } = useCardModel();

    //导入成功
    const upLoadCallback = async (file: any) => {
        if (file) {
            try {
                let fd = new FormData();
                fd.append("file", file); //附件名称
                let res = await cardService.uploadOrg(fd)
                console.log(res)
                convertRes2Blob(res);
                loadData()
                setLoadingInfo({ loadingVisible: false, txt: "" });
            } catch (error) {
                setLoadingInfo({ loadingVisible: false, txt: "" });
            }
        }
    }
    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.ORG_SHOP_AD}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={async () => {
                await loadData();
                message.success("刷新成功")
            }}
        >刷新</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.ORG_SHOP_ED}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                sync()
                // setSyncVisible(true);
            }}
        >人员同步</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.ORG_SHOP_AD}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行操作");
                    return;
                }
                setICardDrawer("edit")
            }}
        >业务配置</Button>
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig1(`/ebc/card/uploadOrg`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: "快速导入中" }))}>
            <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => downloadTpl()}
        >下载模板</Button>
        {/* </YhAuth> */}
    </>;

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}